import React from "react";
import { useFormik } from "formik";
import { BankAccountAddFormValidation } from "./BankAccountAddFormValidation";
import BankAccountAddFormFields from "./BankAccountAddFormFields";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../../utility/Forms/errorValidationApollo";
import { Box, Card, CardContent, Typography } from "@material-ui/core";
import {
  MUTATION_ADD_BANK_ACCOUNT,
  MUTATION_EDIT_BANK_ACCOUNT,
} from "../../../service/ApolloClient/ApolloMutation";
import { withRouter } from "react-router";
import checkDateInput from "../../../utility/CheckDateInput/checkDateInput";
import Wrapper from "../../../hoc/Wrapper/Wrapper";

const validationSchema = BankAccountAddFormValidation;

const BankAccountAddForm = (props) => {
  const { data, isModal } = props;

  let valuesDefault = {
    user_id: "",
    bank: "",
    branch: "",
    branch_code: "",
    account: "",
    ibn: "",
    card: "",
    description: "",
  };

  if (props.isEdit) {
    valuesDefault = {
      ...valuesDefault,
      ...data,
    };
  }

  const formikData = useFormik({
    initialValues: valuesDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      let newValue = values;
      newValue.cleared_at = checkDateInput(values.cleared_at);
      newValue.date = checkDateInput(values.date);

      submitHandle(newValue);
    },
  });

  const submitHandle = (values) => {
    setLoading(true);

    client
      .mutate({
        mutation: props.isEdit
          ? MUTATION_EDIT_BANK_ACCOUNT
          : MUTATION_ADD_BANK_ACCOUNT,
        variables: values,
      })
      .then((result) => {
        let bankAccount = props.isEdit
          ? result.data.editBankAccount
          : result.data.addBankAccount;
        if (bankAccount === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast("درخواست با موفقیت انجام شد ");
        }
        setLoading(false);
        if (isModal) {
          props.handleClose();
        } else {
          props.history.push("/bank-account/edit/" + bankAccount.id);
        }
      })
      .catch((reason) => {
        ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      });

    setLoading(true);
  };

  const [loading, setLoading] = React.useState(false);

  const component = (
    <Wrapper>
      {isModal ? null : (
        <Box ml={2} mb={2} display={"flex"}>
          <Box flexGrow={1} ml={1}>
            <Typography variant={"h5"} align={"left"}>
              {props.isEdit
                ? "ویرایش حساب بانکی " + props.data.id
                : "  افزودن حساب بانکی"}
            </Typography>
          </Box>
        </Box>
      )}
      <BankAccountAddFormFields
        loading={loading}
        isEdit={props.isEdit}
        {...formikData}
      />
    </Wrapper>
  );

  return isModal ? (
    component
  ) : (
    <Box mt={2}>
      <Card>
        <CardContent>{component}</CardContent>
      </Card>
    </Box>
  );
};

export default withRouter(BankAccountAddForm);
